import NavSpacer from '../../components/NavSpacer/NavSpacer';

function AccountBlankPage() {
    return (
        <>
            <NavSpacer />
            <div className="flex flex-col justify-center items-center sm:h-full-nav-sm md:h-full-nav-md lg:h-full-nav-lg xl:h-full-nav-xl">
                <div className="text-mid-grey">Click a menu item to begin</div>
            </div>
        </>
    );
}
export default AccountBlankPage;